export default {
  filters: 'Filtres',
  filtersPlaceholder: "Combinez jusqu'à cinq languages de programmation, logiciels...",
  typeOfProjects: 'Type de projets',
  noResult: 'Aucun projet trouvé...'
}